window.addEventListener('DOMContentLoaded', () => {
    const validate = (input) => {
        let field = input.parentElement.classList;
        let value = input.value;
        let isValid;

        switch (input.name) {
            case 'bankAccountNumber':
                isValid = /^\d{26}$/.test(value);
                break;
            case 'buyerName':
            case 'city':
            case 'firstName':
            case 'flatNumber':
            case 'invoiceNumber':
            case 'lastName':
            case 'password':
            case 'repeatedPassword':
            case 'sellerName':
            case 'street':
            case 'streetNumber':
                isValid = /^.+$/.test(value);
                break;
            case 'buyerNip':
            case 'nip':
            case 'sellerNip':
                isValid = /^\d{10}$/.test(value);
                break;
            case 'clientsNumber':
            case 'income':
            case 'revenue':
                isValid = /^\d+$/.test(value);
                break;
            case 'eMailAddress':
                isValid = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(value);
                break;
            case 'expiryDate':
            case 'issueDate':
                isValid = /^\d{2}.\d{2}.\d{4}$/.test(value) && (new Date(value.split('.')[2], parseInt(value.split('.')[1]) - 1, value.split('.')[0]) >= new Date().setHours(0, 0, 0, 0));
                break;
            case 'grossValue':
            case 'netWorth':
            case 'toPay':
            case 'vatRate':
                isValid = /^\d+[,.]*\d*$/.test(value);
                break;
            case 'identityCardNumber':
                isValid = /^[a-zA-Z]{3}\d{6}$/.test(value);
                break;
            case 'invoiceDate':
            case 'paymentDate':
            case 'saleDate':
                isValid = /^\d{2}.\d{2}.\d{4}$/.test(value);
                break;
            case 'pesel':
                isValid = /^\d{11}$/.test(value);
                break;
            case 'phoneNumber':
                isValid = /^\d{9}$/.test(value);
                break;
            case 'postCode':
                isValid = /^\d\d-\d\d\d$/.test(value);
                break;
        }

        if (isValid) {
            field.add('field--valid');
            field.remove('field--invalid');
        } else {
            field.add('field--invalid');
            field.remove('field--valid');
        }
    };

    document.querySelectorAll('.field__picker').forEach((picker) => {
        picker.addEventListener('focus', () => {
            picker.parentElement.classList.remove('field--valid', 'field--invalid');

            document.querySelectorAll('.day').forEach((day) => {
                day.addEventListener('click', () => {
                    setTimeout(() => {
                        picker.dispatchEvent(new Event('change'));
                    });
                });
            });
        });

        picker.addEventListener('blur', () => {
            validate(picker);
        });

        picker.addEventListener('change', () => {
            validate(picker);
        });
    });

    document.querySelectorAll('.field__input').forEach((input) => {
        input.addEventListener('focus', () => {
            input.parentElement.classList.remove('field--valid', 'field--invalid');
        });

        input.addEventListener('blur', () => {
            validate(input);
        });
    });
});